// UltraFlex — PermissionGate: conditionally renders children based on user's permissions.
// Usage:
//   <PermissionGate perm="members.create"><button>New Member</button></PermissionGate>
//   <PermissionGate anyOf={['members.edit','members.delete']}><AdminActions/></PermissionGate>
//   <PermissionGate perm="members.edit" fallback={<span>Read-only</span>}>...</PermissionGate>
//
// Also exposes `useCan(perm)` hook for inline decisions (e.g. disabling a button
// instead of hiding it).
import React from 'react';
import { useSite } from '../contexts/SiteContext';

export default function PermissionGate({ perm, anyOf, children, fallback = null }) {
  const { hasPermission, hasAnyPermission, loading } = useSite();
  if (loading) return null;
  const allowed = anyOf ? hasAnyPermission(anyOf) : hasPermission(perm);
  return allowed ? <>{children}</> : fallback;
}

// Hook form — use when you need to know yes/no inline
export function useCan(perm) {
  const { hasPermission } = useSite();
  return hasPermission(perm);
}
